import React from 'react';
import { Center, Heading, Image, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import chargerImg from '../../../assets/images/evse_charging_unavailable.svg';
import { SlidingAnimationPageBase } from '../../../common/components/SlidingAnimationPageBase';
import { ScheduleList } from './ScheduleList';

/* istanbul ignore next -- @preserve */
export function DeviceChargingSchedule() {
  const { t } = useTranslation();

  return (
    <SlidingAnimationPageBase title={t('Devices.edit device')} backURL="../device-status" includeTopNavHamButton={true}>
      <Center flexDirection="column" px={3}>
        <Image src={chargerImg} alt="Charging Schedule" mb={4} mx="auto" />

        <Heading mt={2}>{t('EVSE.charging schedule')}</Heading>
        <Text textAlign="center" mt={1}>
          {t('EVSE.schedule text')}
        </Text>

        <ScheduleList />
      </Center>
    </SlidingAnimationPageBase>
  );
}
